// extracted by mini-css-extract-plugin
export default {"wrapper":"swiper_wrapper__rf5tu","slide":"swiper_slide__3F6D9","btn_area":"swiper_btn_area__ZN6JZ","btn":"swiper_btn__ah4RJ","next":"swiper_next__VZB+I","prev":"swiper_prev__HHris"};